export const onloadCallback = () => {
    window.protag = window.protag || {cmd: []}
    if (window.themeConfig.protagWebId !== 'plnezdravi.cz') {
        window.protag.config = {s: window.themeConfig.protagWebId, childADM: '22388916036', l: 'FbM3ys2m'}
    }
    window.protag.cmd.push(function () {
        window.protag.pageInit()
    })
}

export const init = () => {
    let scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', 'https://protagcdn.com/s/' + window.themeConfig.protagWebId + '/site.js')
    scriptTag.setAttribute('defer', 'defer')
    scriptTag.setAttribute('onload', 'window.ads.onloadProtagAds()')
    document.body.appendChild(scriptTag)
}